/**
 * Usage:
 *
 * data-sw-product-price-summary=<productSpin>
 *
 */

var $ = require('./../sw-jquery');
var ShopperSummary = require('./../../lib/views/ShopperSummary.js');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-product-shopper-summary]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swProductShopperSummary');
      var product = ModelManager.getProduct(spin);

      new ShopperSummary({
        el: $el,
        model: product
      });

    });
  });

};
